<div class="fluid-container">
  <div class="row">
    <div class="col-12 text-primary font-weight-bold mb-1 h6">
      {{'DATA_STUDIO.DATA_FILES.TITLE' |translate}}
    </div>
    <div class="col-12 text-primary mb-3">
      <small>
        {{'DATA_STUDIO.DATA_FILES.NOTE' |translate}}
      </small>
    </div>
    <div class="col-12 overflow-auto files-container">
      @for (item of tsFiles; track $index; let i = $index) {
        <div class="row">
          <div class="col-2">
            @if (theme$ === 'light') {
              <div>
                @if (item.fileType === 'xlsx') {
                  <img [alt]="'IMAGE_DESCRIPTION.EXCEL' | translate" src="/assets/data-studio/IconXLS-DarkBlue.svg"
                    class="custom-csv-xls mt-1">
                }
                @if (item.fileType === 'csv') {
                  <img [alt]="'IMAGE_DESCRIPTION.CSV' | translate" src="/assets/data-studio/IconCSV-DarkBlue.svg"
                    class="custom-csv-xls mt-1">
                }
              </div>
            }
            @if (theme$ === 'dark') {
              <div>
                @if (item.fileType === 'xlsx') {
                  <img [alt]="'IMAGE_DESCRIPTION.EXCEL' | translate" src="/assets/data-studio/IconXLS-White.svg"
                    class="custom-csv-xls mt-1">
                }
                @if (item.fileType === 'csv') {
                  <img [alt]="'IMAGE_DESCRIPTION.CSV' | translate" src="/assets/data-studio/IconCSV-White.svg"
                    class="custom-csv-xls mt-1">
                }
              </div>
            }
          </div>
          <div class="col-8 ellipsis">
            <small class="text-primary">{{item.fileName}}</small><br>
            <small class="text-grey">
              {{item?.from?.replaceAll('-', ' ')}} - {{item?.to?.replaceAll('-',
              ' ')}} | {{queryTypes[parseParams(item?.params)?.queryType] |translate}}
              {{type==='live' ? '' : parseParams(item?.params).granularity}}
            </small><br>
            <small class="text-grey">{{parseParams(item?.signals)}}</small>
          </div>
          <div class="col-1">
            @if (item.state == 1 && theme$ === 'light' && downloadingFile !== item._id) {
              <a
                (click)="downloadFile(item)"
                [download]="item.filename">
                <i
                  class="far fa-download custom-download-icon pointer mt-2"
                  [attr.aria-label]="'IMAGE_DESCRIPTION.DOWNLOAD' | translate"
                ></i>
              </a>
            }
            @if (item.state == 1 && theme$ === 'dark' && downloadingFile !== item._id) {
              <a
                (click)="downloadFile(item)"
                [download]="item.filename">
                <i
                  class="far fa-download custom-download-icon pointer mt-2"
                  [attr.aria-label]="'IMAGE_DESCRIPTION.DOWNLOAD' | translate"
                ></i>
              </a>
            }
            @if (downloadingFile === item._id) {
              <div class="spinner-border text-primary mt-2"></div>
            }
          </div>
          <div class="col-1">
            @if (item.state == 1 && theme$ === 'light') {
              <i
                class="far fa-trash-alt custom-delete-icon pointer mt-2"
                [attr.aria-label]="'IMAGE_DESCRIPTION.DELETE' | translate"
                role="button"
                (click)="deleteFile(item)"
              ></i>
            }
            @if (item.state == 1 && theme$ === 'dark') {
              <i
                class="far fa-trash-alt custom-delete-icon pointer mt-2"
                [attr.aria-label]="'IMAGE_DESCRIPTION.DELETE' | translate"
                role="button"
                (click)="deleteFile(item)"
              ></i>
            }
          </div>
          <div class="col-12">
            <hr class="my-1">
          </div>
        </div>
      }
    </div>
  </div>
</div>